module.exports = __webpack_public_path__ + "static/media/video.862e7387.webm";